import { createAsyncThunk } from '@reduxjs/toolkit'
import EventEmitter, {
  SHOW_POPUP_CONFIRMATION,
} from '../../../../helpers/EventEmitter'
import CategoryService from './CategoryService'

export const postCategoryContactUs = createAsyncThunk(
  'contactUs/postCategoryContactUs',
  async (data, { rejectWithValue }) => {
    try {
      const res = await CategoryService.postCategoryContactUs(data)

      if (res.success) {
        EventEmitter.dispatch(
          SHOW_POPUP_CONFIRMATION,
          'domesticSearchPreview.CONTACT_US_CONFIRM',
        )
      }

      return rejectWithValue('Error')
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)
